export const CHANGE_ELEMENTS_COUNT = 'CHANGE_ELEMENTS_COUNT';
export const START_FREE_TRIAL_INIT = 'START_FREE_TRIAL_INIT';
export const START_FREE_TRIAL_DESTROY = 'START_FREE_TRIAL_DESTROY';
export const CHANGE_FREE_TRIAL_COMPRESS = 'CHANGE_FREE_TRIAL_COMPRESS';

export function elementVisibilityChanged({ target, isIntersecting }) {
  return {
    type: CHANGE_ELEMENTS_COUNT,
    payload: { isVisible: isIntersecting, target },
  };
}

export function startFreeTrialInit() {
  return {
    type: START_FREE_TRIAL_INIT,
  };
}

export function startFreeTrialDestroy() {
  return {
    type: START_FREE_TRIAL_DESTROY,
  };
}
